import {Icon, Menu, MenuItem} from 'semantic-ui-react';
import {useEffect, useState} from 'react';
import {MemberDetails} from "./MemberDetails";
import {MemberHistoryList} from "./MemberHistoryList";
import { MemberSchedule } from './MemberSchedule';

export const MemberWrapper = (props) => {

    const [chosenElement, setChosenElement] = useState(props.chosenElement ? props.chosenElement : "View")
    const [pageArgs, setPageArgs] = useState({})

    function changePage(page, args) {
        setChosenElement(page)
        setPageArgs(args)
    }

    useEffect(() => {
        window.history.replaceState(null, "", chosenElement.toLowerCase())
    }, [chosenElement])

    return (
        <>
            <div align="center" style={{paddingBottom: "2rem"}}>
                <div style={{width: "fit-content"}}>
                    <Menu pointing>
                        <MenuItem content={<><Icon color="grey" className="list"/>Details</>} name="View"
                                  onClick={() => setChosenElement('View')} active={chosenElement === 'View'}/>
                        <MenuItem content={<><Icon color="grey" className="history"/>Changelog</>} name="Changelog"
                                  onClick={() => setChosenElement('Changelog')} active={chosenElement === 'Changelog'}/>
                        <MenuItem content={<><Icon color="grey" className="calendar"/>Schedule</>} name="Schedule"
                                  onClick={() => setChosenElement('Schedule')} active={chosenElement === 'Schedule'}/>
                    </Menu>
                </div>
            </div>

            {chosenElement === 'View' && <MemberDetails changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Changelog' && <MemberHistoryList changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Schedule' && <MemberSchedule {...pageArgs} />}
        </>
    );

}
